import _extends from "@babel/runtime-corejs2/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["options", "meta", "input", "isField", "id"],
  _excluded2 = ["required"];
import * as React from 'react';
import { CheckBox } from '@gandi/ui';
import FormField from '../wrappers/FormField';
import FormGroup from '../decorators/FormGroup';
import decorateControl from '../wrappers/decorateControl';
var box = function box(props) {
  var options = props.options,
    meta = props.meta,
    input = props.input,
    isField = props.isField,
    id = props.id,
    extraProps = _objectWithoutProperties(props, _excluded);
  var inputValue = input.value;
  var handleChange = function handleChange(evt) {
    var option = evt.target.value;
    var checkedOptions = _toConsumableArray(inputValue);
    if (evt.target.checked) {
      checkedOptions.push(option);
    } else {
      checkedOptions.splice(checkedOptions.indexOf(option), 1);
    }
    return props.input.onChange(checkedOptions);
  };
  return props.options.map(function (option) {
    return (
      /*#__PURE__*/
      // $FlowFixMe[cannot-spread-inexact]
      React.createElement(CheckBox, _extends({
        key: option.value,
        name: option.name,
        value: option.value,
        onChange: handleChange,
        checked: inputValue.includes(option.value),
        id: option.id || option.name
      }, extraProps), option.label)
    );
  });
};
var CheckBoxField = function CheckBoxField(props) {
  var required = props.required,
    extraProps = _objectWithoutProperties(props, _excluded2);
  // $FlowFixMe[cannot-spread-inexact]
  return /*#__PURE__*/React.createElement(FormField, _extends({
    component: box
  }, extraProps));
};
var component = decorateControl(CheckBoxField, FormGroup);
var CheckboxGroupField = function CheckboxGroupField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({}, props, {
    legend: props.legend || props.label,
    component: component
  }));
};
export default CheckboxGroupField;